
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/[categorySlug]/[newsSlug]",
      function () {
        return require("private-next-pages/news/[categorySlug]/[newsSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/[categorySlug]/[newsSlug]"])
      });
    }
  